import axios from 'axios';
import { getApiBaseUrl } from '../utils/apiConfig';

/**
 * 获取用户信息函数
 * @param {string} token 用户的 JWT Token
 * @returns {Promise<Object>} 返回用户信息
 */
export const getUserInfo = async (token: string): Promise<any> => {
  const apiBaseUrl = getApiBaseUrl();
  const headers = {
    Authorization: `Bearer ${token}`,
  };


  let lastError: any = null;


  try {
    const response = await axios.post(`${apiBaseUrl}/getUserInfo`, {}, { headers });
    if (response.data && response.data.user) {
      const userData = response.data.user;
      return {
        username: userData.username || '',
        email: userData.email || '',
        coin: userData.coin || 0,
        vipLevel: userData.vipLevel || 0,
        vipExpiry: userData.vipExpiry || '',
        birthday: userData.birthday || '',
        birthplace: userData.birthplace || '',
        birthtime: userData.birthtime || '',
        createTime: userData.creatTime || '',
        lastLoginTime: userData.lastLoginTime || '',
        iat: userData.iat,
        exp: userData.exp,
      };
    }
  } catch (error: any) {
    lastError = error;

  }


  const fallbackError =
    lastError ||
    new Error('获取用户信息失败，请检查网络连接');

  if (lastError?.response?.data?.error) {
    throw new Error(lastError.response.data.error);
  }

  throw fallbackError;
};

